import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";

const selectAuth = (state: RootState) => state?.auth;

export default createDraftSafeSelector(selectAuth, (state) => state?.segmentInfo);
